import React from 'react'
import { Route, Switch } from 'react-router'
import ReportDriverPerformanceAnalysis from './ReportDriverPerformanceAnalysis'

const Components = props => (
    <Switch>
        <Route exact path={props.match.url} component={ReportDriverPerformanceAnalysis} />
    </Switch>
)

export default Components
